export { TemplateItemCertificateDocument } from "./TemplateItemCertificateDocument";
